<template>
  <div class="userComp">
    <div class="comp">
      <div class="searchLine">
        <el-select class="selectSearchType" v-model="searchType" @change="changeSearchType">
          <el-option label="顾客" value="vipMember"></el-option>
          <el-option label="宠物" value="vipPet"></el-option>
          <el-option label="散客" value="vipNot"></el-option>
        </el-select>
        <div id="InputBox" v-if="searchType === 'vipMember'">
          <input type="text" v-model="keyword" placeholder="请输入顾客手机号" />
          <div class="Inputlist" v-if="drawerUserList_state">
            <div class="Inputitem" v-for="(item, index) in vipList" :key="item._id"
              :class="{ clicked: index === currentcheckIndex }" @mouseenter="setMouseOut(index)"
              @click="setMouseClick(item._id, index)">
              <span v-html="brightenKeyword(
          (!item.club_card || item.club_card.is_valid == false
            ? ''
            : '[' + 'VIP]') +
          item.basic_info.nick_name +
          (item.basic_info.user_mobile
            ? ' (' + item.basic_info.user_mobile + ')'
            : '(无手机号)'),
          keyword
        )
          "></span>
            </div>
            <div class="Inputitem1" style="
                color: red;
                font-size: 13px;
                text-align: center;
                padding: 10px 0;
              " v-if="vipList === null">
              没有客户信息，请创建客户档案
            </div>
          </div>
        </div>
        <el-select class="selectKeyword" v-if="searchType === 'vipPet'" v-model="keyword" placeholder="请输入宠物昵称"
          filterable remote @change="changePet" :remote-method="remoteMethodPet">
          <el-option v-for="item in petsList" :key="item.pet_id" :label="item.pet_name +
          ' (' +
          item.category_info.name +
          ' ' +
          item.member_name +
          ' ' +
          item.member_mobile +
          ')'
          " :value="item">
          </el-option>
          <template slot="empty">
            <div style="
                width: 300px;
                font-size: 14px;
                color: red;
                text-align: center;
                padding: 10px 0;
              ">
              没有宠物信息，请创建客户档案
            </div>
          </template>
        </el-select>
        <el-select class="selectKeyword" v-if="searchType === 'vipNot'" value="" placeholder="" disabled filterable
          remote></el-select>
      </div>
      <div class="panel">
        <div class="nameLine">
          <img v-if="userInfo.basic_info.sex === '男'" style="
              width: 15px;
              height: 15px;
              margin-left: 2px;
              vertical-align: bottom;
            " src="../../../assets/img/nan.png" />
          <img v-else style="
              width: 15px;
              height: 15px;
              margin-left: 2px;
              vertical-align: bottom;
            " src="../../../assets/img/nv.png" />
          <span class="name">{{ userInfo.basic_info.nick_name || "--" }}</span>
          <span v-if="userInfo.lifeLong && userInfo.lifeLong.status === 1">
            <el-tooltip effect="dark" :content="userInfo.lifeLong.remark" placement="top-start">
              <img style="height: 16px; vertical-align: bottom; cursor: pointer" src="../../../assets/img/zhong.png" />
            </el-tooltip>
          </span>
          <span @click="openDrawer('修改')" style="float: right; margin-left: 2px">
            <img style="width: 20px; cursor: pointer" src="../../../assets/img/mendian/edit.png" />
          </span>
          <span @click="openDrawer('刷新')" style="float: right">
            <img style="width: 20px; cursor: pointer" src="../../../assets/img/mendian/refresh.png" />
          </span>
        </div>
        <div class="panelItem" style="display: flex;">
          <span class="panelLabel">会员：</span>
          <div class="panelLabel valid" v-if="userInfo.club_card.is_valid" @click="BuyCard">
          </div>
          <div class="panelLabel valid1" v-else style="width: 88px;height: 28px;" @click="BuyCard">
          </div>
        </div>
        <div class="panelItem">
          <span class="panelLabel">手机号码：</span>
          <span class="panelLabel">{{ userInfo.basic_info.user_mobile || "--" }}
            <span v-if="userInfo.staff_type === 2" style="font-size: 12px; color: #2aa3f5">内部员工</span>
            <span v-if="userInfo.staff_type === 3" style="font-size: 12px; color: #2aa3f5">离职员工</span>
          </span>
        </div>
        <!-- <div class="panelItem">
					<span class="panelLabel">会员卡号：</span>
					<span class="panelLabel">{{userInfo.card_info.card_id||'--'}}</span>
				</div> -->
        <!-- <div class="panelItem">
					<span class="panelLabel">顾客编号：</span>
					<span class="panelLabel">{{userInfo.user_no ||'--'}}</span>
				</div> -->
        <div class="panelItem">
          <span class="panelLabel">注册地址：</span>
          <span class="panelLabel">
            {{
          userInfo.company_info.shop_id
            ? $public.getShopNameById(userInfo.company_info.shop_id)
            : "--"
        }}
            <span v-if="userInfo.buyPetBackInfo && userInfo.buyPetBackInfo.status === 1
          " style="font-size: 12px; color: #2aa3f5">(新手首购)</span>
            <span v-if="userInfo.buyPetBackInfo && userInfo.buyPetBackInfo.status === 2
          " style="font-size: 12px; color: #2aa3f5">(有宠首购)</span>
            <span v-if="userInfo.buyPetBackInfo && userInfo.buyPetBackInfo.status === 3
          " style="font-size: 12px; color: #2aa3f5">(花生复购)</span>
          </span>
        </div>
        <div class="panelItem">
          <span class="panelLabel">出生日期：</span>
          <span class="panelLabel">
            {{
          userInfo.basic_info.birthday
            ? $public.FTime(userInfo.basic_info.birthday, "YYYY-MM-DD")
            : "--"
        }}
          </span>
        </div>
        <div class="panelItem">
          <span class="panelLabel">备选联系：</span>
          <span class="panelLabel">{{
            userInfo.basic_info.urgent_user || "--"
          }}</span>
        </div>
        <div class="panelItem">
          <span class="panelLabel">紧急电话：</span>
          <span class="panelLabel">{{
            userInfo.basic_info.urgent_user_mobile || "--"
          }}</span>
        </div>
        <div class="panelItem">
          <span class="panelLabel">客户备注：</span>
          <span class="panelLabel" style="
              width: 145px;
              display: inline-block;
              height: 16px;
              vertical-align: sub;
            ">
            <span v-if="userInfo.basic_info.remark &&
          userInfo.basic_info.remark.length > 9
          ">
              <el-tooltip effect="dark" :content="userInfo.basic_info.remark" placement="top-start">
                <div style="
                    width: 100%;
                    overflow: hidden;
                    display: inline-block;
                    height: 16px;
                    line-height: 16px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  ">
                  {{ userInfo.basic_info.remark }}
                </div>
              </el-tooltip>
            </span>
            <span v-else style="
                width: 145px;
                height: 16px;
                line-height: 16px;
                vertical-align: super;
                padding-top: 17px;
              ">
              {{ userInfo.basic_info.remark || "--" }}
            </span>
          </span>
        </div>
        <div class="num">
          <span v-if="dingjinOrder.length > 0" @click="openDingjinPet" style="margin-right: 10px">订金宠物</span>
          <span v-if="userInfo._id !== 'sankeId'" @click="openAddPet" style="margin-right: 10px">添加宠物</span>
          <span v-if="userInfo._id !== 'sankeId'" @click="changeBusiness('回访记录')" style="margin-right: 0px">回访记录</span>
        </div>
      </div>
    </div>
    <el-card class="box-card" @mouseenter.native="setMouseOut2()" v-if="drawerUserInfo_state">
      <div class="box_content">
        <div class="box_title">请确认用户信息</div>
        <div class="Quxiao">
          <img @click="noChangeUser" src="../../../assets/img/Quxiao.png" style="width: 30px; height: 30px" alt="" />
        </div>
        <div class="box_userInfo">
          <div class="box_user" style="width: 30%">
            <!-- <div class="box_L"></div> -->
            <span class="box_Title">会员信息</span>
            <div>
              <span class="pannl_item"> 会员姓名：</span>
              <span>
                {{ newUserInfo.basic_info.nick_name || "--" }}
                <span v-if="newUserInfo.staff_type === 2" style="font-size: 12px; color: #2aa3f5">（内部员工）</span>
                <span v-if="newUserInfo.staff_type === 3" style="font-size: 12px; color: #2aa3f5">（离职员工）</span>
              </span>
            </div>

            <div>
              <span class="pannl_item">会员余额：</span>
              <span> {{ newUserInfo.card_info.user_yue || "--" }}</span>
            </div>
            <div>
              <span class="pannl_item">是否是会员：</span>
              <span>{{ newUserInfo.club_card.is_valid ? 'Yes' : 'No' }}</span>
            </div>
            <div>
              <span class="pannl_item">会员剩余天数：</span>
              <span>{{ newUserInfo.club_card.surplus_day || '--' }}</span>
            </div>
            <div>
              <span class="pannl_item">手机号码：</span>
              <span>{{ newUserInfo.basic_info.user_mobile || "--" }}</span>
            </div>

            <div>
              <span class="pannl_item">注册地址：</span>
              <span>
                {{
          newUserInfo.company_info.shop_id
            ? $public.getShopNameById(newUserInfo.company_info.shop_id)
            : "--"
        }}
              </span>
            </div>

            <div>
              <span class="pannl_item">出生日期：</span>
              <span>
                {{
            newUserInfo.basic_info.birthday
              ? $public.FTime(
                newUserInfo.basic_info.birthday,
                "YYYY-MM-DD"
              )
              : "--"
          }}
              </span>
            </div>
          </div>
          <div class="box_pet">
            <!-- <div class="box_L"></div> -->
            <div style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              ">
              <span class="box_Title">宠物信息</span>
              <span><el-input id="petInput" placeholder="请输入宠物名称" v-model="input" @input="changeSearch"
                  @keyup.enter.native="changeSearch">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="changeSearch"></i></el-input></span>
            </div>

            <div class="header_tab" ref="headertab">
              <ul ref="tabitem" v-if="userPetList.length">
                <li @click="changePetList(item._id)" :class="curPetId === item._id ? 'activeheader' : ''"
                  v-for="item in userPetList" :key="item.id">
                  <img v-if="item.apply_type.title == '犬' && !item.avatar_pic" src="../../../assets/img/catImg.png"
                    alt="" />
                  <img v-if="item.avatar_pic" :src="item.avatar_pic" alt="" />
                  <img v-if="item.apply_type.title == '猫' && !item.avatar_pic" src="../../../assets/img/dogImg.png"
                    alt="" />

                  <div class="petList_img">
                    <div>{{ item.nick_name }}</div>
                    <div>
                      <span>{{ item.category_info.name }} </span><span>|</span><span>{{ item.pet_sex }} </span>
                      <span>|</span><span>{{ item.weight }}KG</span>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="box_pet" v-if="!userPetList.length">
                <span class="box_Title">暂无宠物信息</span>
              </div>
            </div>
          </div>
        </div>

        <div style="text-align: left; margin: -70px 0 0 80px">
          <el-button type="warning" size="medium" @click.native="changeMember(newUserInfo._id)">确定</el-button>
        </div>
      </div>
    </el-card>

    <drawerEditUserInfo v-if="drawerEditUserInfo_state" :userInfo="userInfo" @submit="submit_drawerEditUserInfo">
    </drawerEditUserInfo>
    <drawerAddEditUserInfo v-if="drawerAddEditUserInfo_state" :dialog_type="'addPet'" :userInfo="userInfo"
      @submit="submit_drawerAddEditUserInfo"></drawerAddEditUserInfo>
    <!-- <drawerUserInfo v-if="drawerUserInfo_state"></drawerUserInfo> -->
    <!-- 购买会员卡 -->
    <div v-if="dialogBuyCard_state">
      <dialogBuyCard @submit="dialogCard_submit"></dialogBuyCard>
    </div>
  </div>

</template>
<script>
import drawerEditUserInfo from "../../../components/drawer/drawer_editUserInfo.vue";
import drawerAddEditUserInfo from "../../../components/drawer/drawer_addEditPetInfo.vue";
import dialogBuyCard from "../../../components/drawer/drawer_BuyCard.vue";
export default {
  components: { drawerEditUserInfo, drawerAddEditUserInfo, dialogBuyCard },

  data() {
    return {
      isShow: false,
      userId: "",
      searchType: "vipMember",
      keyword: "",
      vipList: [],
      petsList: [],
      drawerEditUserInfo_state: false,
      drawerAddEditUserInfo_state: false,
      drawerUserInfo_state: false, //确认用户信息
      drawerUserList_state: false,
      // 购买会员卡
      dialogBuyCard_state: false,
      grades: "",
      shop_id: "",
      addUserInfo: null,
      userPetList: [],
      searchUserPetList: [],
      basic_info: {
        nick_name: "",
        user_mobile: "",
        birthday: "",
        urgent_user: "",
        urgent_user_mobile: "",
        remark: "",
      },
      //
      newId: "",
      newUserInfo: null,
      curPetId: "",
      input: "", //搜索宠物
      currentcheckIndex: 0,
      CardId: '',
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
          _id: "",
        };
      }
    },
    cardCount() {
      return this.$store.state.mendian.cardCount;
    },
    dingjinOrder() {
      return this.$store.state.mendian.dingjinOrder;
    },
    huiyuanquanyiNum() {
      return this.$store.state.mendian.huiyuanquanyiNum;
    },
    saleList() {
      return this.$store.state.mendian.saleList;
    },
  },
  mounted() {

    // setTimeout(() => {
    // console.log(this.curPetId,"timer");
    // }, 2000)
    if (this.$store.state.yuyueUserId) {
      this.userId = this.$store.state.yuyueUserId;
      this.searchType = "vipMember";
      this.$http.get(process.env.VUE_APP_Url_member + "/api/middleware/Member/Single", { id: this.userId }).then((res) => {
        if (res.code == 0) {
          this.$store.commit("mendian/set_userInfo", res.data);
          this.$store.commit("mendian/set_curBusiness", "洗美");
        }
      });
    }
    if (!this.$public.isNull(this.userInfo._id)) {
      if (this.userInfo._id === "sankeId") {
        this.searchType = "vipNot";
      } else {
        this.$store.dispatch("mendian/getUserInfo", this.userInfo._id);
        this.$util.getControllerForMember(this.userInfo._id).then((res) => {
          this.$store.commit("mendian/set_userController", res);
        });
      }
    }
    this.reMember();
  },
  watch: {
    keyword() {
      if (this.keyword) {
        this.reMember(this.keyword);
        this.drawerUserList_state = true;
      } else {
        this.drawerUserList_state = false;
        this.drawerUserInfo_state = false;
      }
    },
  },
  methods: {
    // 购买会员卡
    BuyCard() {
      if (!this.$public.isNull(this.userInfo._id)) {
        this.dialogBuyCard_state = true;
      }

    },
    dialogCard_submit(data) {
      console.log(data, 'dfata');
      this.CardId = data.id
      this.dialogBuyCard_state = false;
    },
    // 搜索顾客关键字加粗
    brightenKeyword(val, keyword) {
      const Reg = new RegExp(keyword, "i");
      if (val) {
        const res = val.replace(
          Reg,
          `<span style="font-weight:700;font-size:15px;color:#f5882a">${keyword}</span>`
        );
        return res;
      }
    },
    noChangeUser() {
      // console.log("展开", a);
      this.keyword = "";
      this.newId = "";
      this.vipList = [];
      this.drawerUserInfo_state = false;
    },
    changeSearch() {
      this.userPetList = [];
      let arr = this.searchUserPetList.filter((item) => {
        return item.nick_name.includes(this.input);
      });
      this.userPetList = arr;
      // this.input = "";
    },

    changePetList(id) {
      // console.log(id);
      this.curPetId = id;
      // this.$store.commit("mendian/set_curPetId", "");
      this.$store.commit("mendian/set_curPetId", id);
    },
    //触发
    // setMouseOver() {
    //   if (this.saleList.length > 0) {
    //     this.$message({
    //       message: "消费列表中已录入商品，请先挂单或重置",
    //       type: "error",
    //     });
    //     this.keyword = "";
    //     return;
    //   } else {
    //     // this.drawerUserInfo_state = true;
    //     if (id) {
    //       this.getPetListData(id);
    //     }
    //     let userInfo = this.vipList.filter((item) => {
    //       return item._id == id;
    //     })[0];
    //     this.newUserInfo = userInfo;
    //     this.newId = userInfo._id;
    //     this.basic_info = userInfo.basic_info;
    //     this.grades = userInfo.club_card. surplus_day;
    //     this.shop_id = userInfo.company_info.shop_id;
    //   }
    // },
    // 鼠标移入
    setMouseOut(num) {
      if (num !== 0) {
        return;
      } else {
        this.newUserInfo = this.vipList[0];
        this.userPetList = this.newUserInfo.pets_info;
        this.searchUserPetList = this.newUserInfo.pets_info;
        this.drawerUserInfo_state = true;
        this.curPetId = "";
      }
      console.log("一上去", num);
    },
    // 鼠标点击
    setMouseClick(id, index) {
      this.currentcheckIndex = index
      if (this.newId == id) {
        return;
      } else {
        this.newId = id;
      }
      this.newUserInfo = this.vipList.filter((item) => {
        return item._id == id;
      })[0];
      console.log(this.newUserInfo);
      this.userPetList = this.newUserInfo.pets_info;
      this.searchUserPetList = this.newUserInfo.pets_info;
      this.drawerUserInfo_state = true;
      this.curPetId = "";

      console.log("用户信息----------", this.newUserInfo);
    },
    setMouseOut2() {
      this.drawerUserInfo_state = true;
    },
    // 搜索
    changeSearchType(val) {
      if (this.userInfo._id.length > 0) {
        if (val !== "vipNot" && this.userInfo._id === "sankeId") {
          // 散客 切换成 会员 时判断
          if (this.saleList.length > 0) {
            this.$message({
              message: "消费列表中已录入商品，请先挂单或重置",
              type: "error",
            });
            return;
          }
          this.$store.commit("mendian/set_cardCount", {
            card_count: 0,
            coupon_count: 0,
          });
          this.$store.commit("mendian/set_huiyuanquanyiNum", 0);
          this.$store.commit("mendian/set_dingjinOrder", []);
          this.$store.commit("mendian/reset");
          this.$store.commit("mendian/set_isSanke", false);
        } else if (val === "vipNot" && this.userInfo._id.length > 10) {
          // 会员 切换成 散客 时判断
          if (this.saleList.length > 0) {
            this.$message({
              message: "消费列表中已录入商品，请先挂单或重置",
              type: "error",
            });
            return;
          }
          this.$store.commit("mendian/set_cardCount", {
            card_count: 0,
            coupon_count: 0,
          });
          this.$store.commit("mendian/set_huiyuanquanyiNum", 0);
          this.$store.commit("mendian/set_dingjinOrder", []);
          this.$store.commit("mendian/reset");
          this.$store.commit("mendian/set_isSanke", true);
        } else {
          console.log("顾客和宠物互切");
        }
      } else {
        if (val === "vipNot") {
          if (this.saleList.length > 0) {
            this.$message({
              message: "消费列表中已录入商品，请先挂单或重置",
              type: "error",
            });
            return;
          }
          this.$store.commit("mendian/set_cardCount", {
            card_count: 0,
            coupon_count: 0,
          });
          this.$store.commit("mendian/set_huiyuanquanyiNum", 0);
          this.$store.commit("mendian/set_dingjinOrder", []);
          this.$store.commit("mendian/reset");
          this.$store.commit("mendian/set_isSanke", true);
        }
        console.log("首次搜索");
      }
    },

    changeOut2() {
      // this.drawerUserInfo_state = false;
    },
    changeUser() {
      this.drawerUserInfo_state = false;
    },
    changeMember(id) {
      if (this.saleList.length > 0) {
        this.$message({
          message: "消费列表中已录入商品，请先挂单或重置",
          type: "error",
        });
        this.keyword = "";
        return;
      } else {
        if (id) {
          this.$store.commit("mendian/reset");
          let userInfo = this.vipList.filter((item) => {
            return item._id == id;
          })[0];
          this.$store.commit("mendian/set_userInfo", userInfo);
          this.$util.getControllerForMember(id).then((res) => {
            this.$store.commit("mendian/set_userController", res);
          });
          this.vipList = [];
          this.keyword = "";
          this.$store.dispatch("mendian/get_unPayOrderList");
          this.$store.dispatch("mendian/newGetUserInfo", id); //
          this.$store.commit("huiyuanquanyi/set_type", "list");
          this.$store.commit("mendian/set_curPetId", this.curPetId);
          this.drawerUserInfo_state = false;
        }
        console.log("确定", this.$store.state.mendian.curPetId);
      }
    },
    changePet(item) {
      if (this.saleList.length > 0) {
        this.$message({
          message: "消费列表中已录入商品，请先挂单或重置",
          type: "error",
        });
        return;
      } else {
        let params = {
          id: item.member_id,
        };
        this.$http.get(process.env.VUE_APP_Url_member + "/api/middleware/Member/Single", params).then((res) => {
          if (res.code == 0) {
            this.$store.commit("mendian/set_userInfo", res.data);
            this.$store.commit("mendian/set_curPetId", item.pet_id);
            this.$store.commit("mendian/set_curNavPanelPet", "1");
            this.petsList = [];
            this.keyword = "";
          }
        });
      }
    },

    reMember(str) {
      // console.log('str',str);
      this.$util.getVipList(str).then((list) => {
        this.vipList = list;
      });
    },
    remoteMethodPet(str) {
      this.$util.getPetList(str).then((list) => {
        this.petsList = list;
      });
    },
    // 添加宠物
    openAddPet() {
      if (this.userInfo._id.length > 10) {
        this.drawerAddEditUserInfo_state = true;
      } else {
        this.$message({
          message: "请选择会员",
          type: "error",
        });
        return;
      }
    },
    submit_drawerAddEditUserInfo(b) {
      this.drawerAddEditUserInfo_state = false;
      if (b === true) {
        this.$http
          .get(process.env.VUE_APP_Url_member + "/api/middleware/Member/Single", { id: this.userInfo._id })
          .then((res) => {
            if (res.code == 0) {
              this.$store.commit("mendian/set_userInfo", res.data);
              this.$store.commit(
                "mendian/set_curPetId",
                res.data.pets_info[res.data.pets_info.length - 1]._id
              );
            }
          });
      }
    },
    // 订金宠物
    openDingjinPet() {
      this.$store.commit("mendian/set_curBusiness", "活体");
      this.$store.commit("living/set_type", "dingList");
    },
    // 回访记录
    changeBusiness(str) {
      // if(str==='押金'){
      // 	this.$store.commit('mendian/set_curBusiness','ing')
      // 	this.$store.commit('ing/set_imgType','coding')
      // 	this.$store.commit('ing/set_text','正在开发中...')
      // 	return ;
      // }
      // if(str==='积分'){
      // 	this.$store.commit('mendian/set_curBusiness','ing')
      // 	this.$store.commit('ing/set_imgType','coding')
      // 	this.$store.commit('ing/set_text','正在开发中...')
      // 	return ;
      // }
      // if(str==='会员权益'){
      // 	this.$store.commit('mendian/set_curBusiness','ing')
      // 	this.$store.commit('ing/set_imgType','coding')
      // 	this.$store.commit('ing/set_text','正在开发中...')
      // 	return ;
      // }
      if (this.userInfo._id.length > 10) {
        this.$store.commit("mendian/set_curBusiness", str);
      } else {
        this.$message({
          message: "请选择会员",
          type: "error",
        });
        return;
      }
    },
    // 编辑用户信息
    openDrawer(str) {
      if (this.userInfo._id.length > 10) {
        if (str === "修改") {
          this.drawerEditUserInfo_state = true;
        } else if (str === "刷新") {
          this.$store.dispatch("mendian/getUserInfo", this.userInfo._id);
        }
      } else {
        this.$message({
          message: "请选择会员",
          type: "error",
        });
        return;
      }
    },
    submit_drawerEditUserInfo(b) {
      this.drawerEditUserInfo_state = false;
      if (b === true) {
        this.$http
          .get(process.env.VUE_APP_Url_member + "/api/middleware/Member/Single", { id: this.userInfo._id })
          .then((res) => {
            if (res.code == 0) {
              this.$store.commit("mendian/set_userInfo", res.data);
            }
          });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.userComp {
  width: 252px;

  .comp {
    width: 252px;

    .searchLine {
      display: flex;

      .selectSearchType {
        width: 60px;
        height: 33px;

        ::v-deep .el-input {
          &.is-focus {
            .el-input__inner {
              border-color: #dcdfe6;
            }
          }

          .el-input__inner {
            line-height: 33px;
            height: 33px;
            padding: 0 5px 0 7px;
            border-radius: 4px 0 0 4px;
            color: $mainColor;

            &:focus {
              border-color: #dcdfe6;
            }
          }

          .el-input__suffix {
            right: 1px;

            .el-input__suffix-inner {
              .el-select__caret {
                line-height: 33px;
                color: $mainColor;
              }
            }
          }
        }
      }

      .selectKeyword {
        width: 192px;
        height: 33px;


        ::v-deep .el-input {
          &.is-focus {
            .el-input__inner {
              border-color: #dcdfe6;

            }
          }

          .el-input__inner {
            line-height: 33px;
            height: 33px;
            border-radius: 0 4px 4px 0;

            &:focus {
              border-color: #dcdfe6;

            }
          }

          .el-input__suffix {
            right: 1px;

            .el-input__suffix-inner {
              .el-select__caret {
                line-height: 33px;
              }
            }
          }
        }
      }
    }

    .valid {
      width: 88px;
      height: 28px;
      background-image: url(../../../assets/img/mendian/Isvalid.png);
      background-size: 100%;
    }

    .valid1 {
      width: 88px;
      height: 28px;
      background-image: url(../../../assets/img/mendian/valid.png);
      background-size: 100%;
    }

    .panel {
      display: inline-block;
      width: 100%;
      height: 278px;
      margin-top: 12px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 10px 12px 10px 12px;
      border-radius: 4px;

      .nameLine {
        padding-bottom: 8px;

        .name {
          font-size: 14px;
          font-weight: bold;
          color: #2a2a2a;
        }

        .sex {
          width: 10px;
          height: 10px;
        }
      }

      .panelItem {
        font-size: 12px;
        color: #666666;
        line-height: 30px;

        .panelLabel {
          .star {
            width: 20px;
            vertical-align: middle;
          }

          .discount {
            color: #f52a2a;
          }
        }
      }

      .num {
        font-size: 12px;
        color: $mainColor;
        padding: 6px 0;
        cursor: pointer;
      }
    }
  }
}

::v-deep .el-card__body {
  padding: 0px;
}

.box_content {
  font-size: 14px;
  width: 929px;
  height: 584px;
  position: absolute;
  background: #fff;
  padding: 20px;
  z-index: 999;
  top: 46px;
  left: 268px;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 2px #ccc;
}

.box_title {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  margin: 20px 0;
}

.Quxiao {
  position: absolute;
  top: 10px;
  right: 10px;
}

.box_userInfo {
  display: flex;
  justify-content: space-around;

  .box_user {
    width: 435px;
    height: 345px;
    background: #fafafa;
    border-radius: 12px;
    border: 1px solid #f0f0f0;

    div {
      padding: 10px 10px;
      font-size: 14px;

      span:nth-child(2) {
        color: #2a2a2a;
        font-weight: 600;
      }
    }
  }

  .box_pet {
    width: 68%;
    height: 455px;
    background: #fafafa;
    border-radius: 12px;
    // border: 1px solid #f0f0f0;
    overflow: hidden;
  }

  .box_Title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 50px;
    margin-left: 10px;
  }
}

.petList_img {
  text-align: center;

  div:nth-child(1) {
    font-weight: 600;
    font-size: 15px;
    margin: 15px 0;
  }

  div:nth-child(2) {
    font-weight: 500;
    font-size: 15px;

    span {
      margin: 0 2px;
    }
  }
}

.header {
  width: 100%;
  height: 40px;
  background-color: #fff;
  display: flex;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.header_tab {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow: scroll;
  padding-left: 6px;
  padding-right: 19px;
  // 平滑滚动
  transition: all 0.05s linear;
  scroll-behavior: smooth;
}

.header_tab::-webkit-scrollbar {
  display: none;
}

.header_tab>ul {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0;
  padding-left: 0;
  height: 410px;
  overflow: hidden; // 超出部分隐藏
  overflow-y: scroll; // 设置y轴方向的滚动条
}

.header_tab>ul>li {
  display: inline-block;
  width: 173px;
  height: 223px;
  background-color: #fff;
  font-size: 13px;
  color: #333;
  margin-right: 10px;
  // border: 1px solid rgb(180, 180, 180,.3);
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 0px 1px 0px rgba(139, 138, 138, 0.75);
  // 点击高亮某一项时,将原来的字体变大,会导致没有高亮的元素距离底部有空隙,会出现纵向滚动条
  // margin-top: -1px;
}

.header_tab>ul>li>img {
  width: 173px;
  height: 141px;
}

// 隐藏滚动条
.header_tab>ul::-webkit-scrollbar {
  width: 0 !important;
  height: 0px !important;
}
</style>
<style lang="scss">
.activeheader {
  font-size: 14px;
  background-color: #868688;
  border: 1px solid orange;
  color: #fff;
  position: relative;

  &:after {
    position: absolute;
    content: "";
    width: 18px;
    height: 2px;
    bottom: 0;
    left: calc(50% - 9px);
    border-radius: 1px;
  }
}

#selectKey {
  width: 255px;
  height: 65px;
  line-height: 65px;
  text-align: center;
}

.el-select-dropdown__wrap {
  max-height: 412px;
}

// .el-popper{
//    position: absolute;
//     top: 161px;
//     left: 149px ;
// }
.el-select-dropdown__item.is-disabled {
  color: #121213;
  cursor: pointer;
  background-color: rgb(250, 245, 245);
}

.star {
  width: 20px;
  vertical-align: middle;
}

.el-input--suffix {
  width: 100%;
}

#petInput {
  padding: 0 10px;
}

#petInput>.el-input__inner {
  width: 30%;
  display: block;
  float: right;
}

.el-button--medium {
  padding: 20px 50px;
}

#InputBox {
  input {
    width: 106%;
    height: 30px;
    background: rgb(255, 255, 255);
    outline: none;
    border: 1px solid rgb(233, 232, 232);
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  input::placeholder {
    color: rgb(190, 185, 185, 0.8);
  }

  .Inputlist {
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    z-index: 99999;
    overflow: hidden;
    position: absolute;
    top: 39px;
    left: 0;
    width: 95%;
    max-height: 410px;
    overflow: hidden; // 超出部分隐藏
    overflow-y: scroll; // 设置y轴方向的滚动条
    box-shadow: 1px 1px 3px 0px rgba(139, 138, 138, 0.75);
    border-radius: 5px;
    min-height: 30px;
  }

  .Inputitem {
    text-align: center;
    width: 100%;
    height: 30px;
    line-height: 30px;
    padding: 14px 0;
    background-color: #fff;

  }

  .clicked {
    background-color: orange;
    color: #f2f3f7;
    z-index: 99;
  }

  .Inputitem1 {
    text-align: center;
    width: 100%;
    height: 30px;
    line-height: 30px;
    padding: 14px 0;
    background-color: #fff;
  }

  .Inputitem:hover {
    // background-color: #f2f3f7;

  }

  .Inputlist::-webkit-scrollbar {
    width: 0 !important;
    height: 0px !important;
  }
}
</style>
